import { render, staticRenderFns } from "./infoIcon.vue?vue&type=template&id=a63f0f10"
import script from "./infoIcon.vue?vue&type=script&lang=js"
export * from "./infoIcon.vue?vue&type=script&lang=js"
import style0 from "./infoIcon.vue?vue&type=style&index=0&id=a63f0f10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports